<template>
  <v-container fluid class="pa-0 ma-8">
    <v-text-field
      v-model="search"
      :label="$t('search_by_customer')"
      append-inner-icon="mdi-magnify"
      variant="outlined"
      rounded
      class="mx-auto"
      width="50%"
    ></v-text-field>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="filteredCustomers"
      :sort-by="[{ key: 'name', order: 'asc' }]"
      class="elevation-3 rounded-lg"
    >
      <template v-slot:no-data>
        <h3>No data available</h3>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>الزبائن</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <DialogCustomer
            :item="item"
            :saveFunction="save"
            mode="add"
            iconName="mdi-plus"
          />
          <DialogCustomerComplex
            :item="item"
            :parents="parents"
            :saveFunction="save"
            mode="add"
            iconName="mdi-plus"
          />
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-row>
          <DialogCustomer
            :item="item"
            :saveFunction="save"
            mode="edit"
            iconName="mdi-pencil"
          />

          <DialogSimp
            :v-model="dialogSimp"
            iconName="mdi-delete"
            :item="item"
            :confirmFunction="deleteItem"
            :message="messages.delete"
          />
          <DialogCustGroups
            :v-model="dialogGroups"
            iconName="mdi-group"
            :customer="item"
            :groups="groups"
          />
          <DialogCustMeters
            :v-model="dialogMeters"
            iconName="mdi-speedometer"
            :customer="item"
            :meters="meters"
          />
        </v-row>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <v-container>
          <p>{{ $t(`${item.status}`) }}</p>
        </v-container>
      </template>
    </v-data-table>
  </v-container>
  <overlay-loader v-model="loading" />
</template>
<script>
import DialogCustomer from "@/components/dialogs/DialogCustomer.vue";
import DialogCustomerComplex from "@/components/dialogs/DialogCustomerComplex.vue";
import DialogSimp from "@/components/DialogSimp.vue";
import DialogCustGroups from "@/components/dialogs/DialogCustGroups.vue";
import DialogCustMeters from "@/components/dialogs/DialogCustMeters.vue";

import repo from "@/store/repo.js";
import swalFun from "@/plugins/swalFun";
import OverlayLoader from "@/components/common/OverlayLoader.vue";

export default {
  components: {
    DialogCustomer,
    DialogCustomerComplex,
    DialogSimp,
    DialogCustGroups,
    OverlayLoader,
    DialogCustMeters,
  },
  data: () => ({
    search: "",
    loading: false,
    headers: [
      { title: "الاسم", key: "name" },
      { title: "الجوال", key: "phone" },
      { title: "العنوان", key: "address" },
      { title: "الرصيد", key: "balance" },
      { title: "العمليات", key: "actions" },
    ],
    dialog: false,
    dialogSimp: false,
    editedIndex: -1,
    messages: {
      delete: "هل أنت متأكد",
    },
  }),
  computed: {
    customers() {
      return repo.customers.getAllCustomers();
    },
    filteredCustomers() {
      if (this.search.trim() == "") {
        return this.customers;
      }
      return this.customers.filter((customer) => {
        return customer.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    groups() {
      return repo.groups.getAllGroups();
    },
    meters() {
      return repo.meters.getAllMeters();
    },
    parents() {
      //return this.meters;
      return this.meters.filter((meter) => {
        return meter.isFinal == false;
      });
    },
  },
  methods: {
    async fetch() {
      this.loading = true;
      const res1 = await repo.customers.fetchAll();
      const res2 = await repo.groups.fetchAll();
      const res3 = await repo.meters.fetchAll();
      if (res1 && res2 && res3) {
        //swalFun.success("success");
      } else {
        swalFun.fail("error");
      }
      this.loading = false;
    },
    async save(formData, mode) {
      if (mode == "add") {
        //create a customer
        console.log("form", mode, formData);
        const res = await repo.customers.add(formData);
        if (res) {
          swalFun.success("success");
        } else {
          swalFun.fail("error");
        }
      } else {
        //update a customer
        console.log("form", mode, formData);
        const res = await repo.customers.update(formData);
        if (res) {
          swalFun.success("success");
        } else {
          swalFun.fail("error");
        }
      }
    },
    async deleteItem(item) {
      const res = await repo.customers.delete(item.id);
      if (res) {
        swalFun.success("success");
      } else {
        swalFun.fail("error");
      }
      //console.log("item to delete:", item.id);
    },
    activateItem(item) {
      console.log("item to activate:", item);
    },
    deactivateItem(item) {
      console.log("item to deactivate:", item);
    },
  },
  async mounted() {
    await this.fetch();
  },
};
</script>
